import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { MsalService } from '@azure/msal-angular';
import { Subscription } from 'rxjs';
import { DataStoreApiService } from './shared/services/data-store/data-store-api.service';
import { DataStore } from './shared/storage/data-store/data-store';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavMenuComponent],
  templateUrl: './app.component.html',
  // styleUrl: './app.component.scss'
})

export class AppComponent {
  private subscription = new Subscription();
  private readonly dataStoreApi = inject(DataStoreApiService);
  private readonly dataStore = inject(DataStore);
  title = 'XReg';

  constructor(private authService: MsalService) {}

  ngOnInit() {
    this.subscription.add(
      this.authService.handleRedirectObservable().subscribe({
        next: (result) => {
          if (result) {
            this.authService.instance.setActiveAccount(result.account);
          }
          if (!this.dataStore.hasData()) {
            this.dataStoreApi.getInitialData().subscribe({
              next: (data) => this.dataStore.replaceAll(data),
              error: (error) => console.error('Failed to load initial data from the API:', error),
            });
          }
        },
        error: (error) => console.log(error),
      })
    );
  }

  ngonDestroy(): void {
    this.subscription.unsubscribe();
  }
}
